"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CookieBanner: function() {
        return CookieBanner;
    },
    default: function() {
        return _default;
    }
});
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _safelinks = require("@stripe-internal/safe-links");
const _stripecookies = require("@stripe-internal/stripe-cookies");
const _helpers = require("../helpers");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function CookieBanner({ config, onAccept, onReject, onClose, styles }) {
    const { id, content, behavior = {} } = config;
    const cookies = (0, _react.useMemo)(()=>new _stripecookies.Cookies(), []);
    const finalBehavior = _object_spread({
        autoHide: true,
        position: 'bottom',
        animated: true
    }, behavior);
    const handleAccept = (0, _react.useCallback)(()=>{
        cookies.allowAll();
        onAccept(id);
        if (finalBehavior.autoHide) {
            onClose(id);
        }
    }, [
        onAccept,
        onClose,
        id,
        finalBehavior.autoHide,
        cookies
    ]);
    const handleReject = (0, _react.useCallback)(()=>{
        cookies.rejectAll();
        onReject(id);
        if (finalBehavior.autoHide) {
            onClose(id);
        }
    }, [
        onReject,
        onClose,
        id,
        finalBehavior.autoHide,
        cookies
    ]);
    return /*#__PURE__*/ _react.default.createElement("div", {
        className: (0, _helpers.getClassName)('CookieBanner', styles),
        "data-testid": `cookie-consent-${id}`,
        role: "banner",
        "aria-label": "Cookie consent",
        style: {
            pointerEvents: 'all'
        }
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: (0, _helpers.getClassName)('CookieBanner__Body', styles)
    }, (content === null || content === void 0 ? void 0 : content.description) || /*#__PURE__*/ _react.default.createElement("p", null, "We use cookies to improve your experience and for marketing. Read our", ' ', /*#__PURE__*/ _react.default.createElement(_safelinks.SafeAnchor, {
        href: _stripecookies.COOKIE_POLICY_URL,
        className: (0, _helpers.getClassName)('CookieBanner__Link', styles),
        target: "_blank",
        rel: "noopener noreferrer"
    }, "cookie policy"), ' or ', /*#__PURE__*/ _react.default.createElement(_safelinks.SafeAnchor, {
        href: _stripecookies.COOKIE_SETTINGS_PAGE_URL,
        className: (0, _helpers.getClassName)('CookieBanner__Link', styles),
        target: "_blank",
        rel: "noopener noreferrer"
    }, "manage cookies"), ".")), /*#__PURE__*/ _react.default.createElement("div", {
        className: (0, _helpers.getClassName)('CookieBanner__Actions', styles)
    }, /*#__PURE__*/ _react.default.createElement("button", {
        onClick: handleAccept,
        "data-testid": `accept-button-${id}`,
        type: "button",
        className: (0, _helpers.getClassName)('CookieBanner__Button', styles)
    }, (content === null || content === void 0 ? void 0 : content.acceptButton) || 'Accept all'), /*#__PURE__*/ _react.default.createElement("button", {
        onClick: handleReject,
        "data-testid": `reject-button-${id}`,
        type: "button",
        className: (0, _helpers.getClassName)('CookieBanner__Button', styles)
    }, (content === null || content === void 0 ? void 0 : content.rejectButton) || 'Reject all')));
}
const _default = CookieBanner;

//# sourceMappingURL=CookieBanner.js.map